import { SimpleBanner } from '@/components/Banners/SimpleBanner'
import { ReactComponent as InfoIcon } from '@/assets/icons/info-icon.svg'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import './no-results.sass'

function NoMessagesComponent () {
  const messages = useSelector(state => state.messages)

  function getPrintableMessage () {
    if (messages.messageSearchValue && messages.messageSearchValue !== '') {
      const filteredMessageValue = messages.messageSearchValue.length > 60 ? messages.messageSearchValue.substring(0, 60) + '...' : messages.messageSearchValue
      return `Nothing found for ${filteredMessageValue} string`
    } else {
      return 'No messages.'
    }
  }

  useEffect(() => {

  }, [messages])

  return (
    <>
      <div className="no-messages-container">
        <SimpleBanner type='info'>
          <InfoIcon style={{ display: 'inline-block', position: 'relative', top: '-1px', marginRight: '8px' }}/>
          {getPrintableMessage()}
        </SimpleBanner>
      </div>
    </>
  )
}

export default NoMessagesComponent
